import type { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

export const handleLogout = ({ router }: { router: AppRouterInstance }) => {
  const searchParameters = new URLSearchParams(globalThis.location.search);

  const isEditMode =
    searchParameters.get("mgnlPreview") === "false" &&
    searchParameters.has("mgnlChannel");

  if (isEditMode) {
    return;
  }

  const returnUrl = searchParameters.get("returnUrl")?.toString();
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty string needs to fall back to "/"
  router.push(returnUrl || "/");
};
